(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-inventory"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Function to initialize an inventory element
    function initInventoryElement(element, index) {
      console.log('[INVENTORY DEBUG] Initializing inventory element', index);
      const infoButton = element.querySelector('.product-inventory__info-button');
      const popup = element.querySelector('.product-inventory__popup');
      const closeButton = element.querySelector('.product-inventory__popup-close');
      const overlay = element.querySelector('.product-inventory__popup-overlay');
      const popupText = element.querySelector('.product-inventory__popup-text');
      
      // Get the popup content from data attributes
      const inStockText = element.dataset.inStockText || '';
      const lowStockText = element.dataset.lowStockText || '';
      const backorderText = element.dataset.backorderText || '';
      
      // Function to detect current status based on inventory data
      function detectCurrentStatus() {
        // Get current inventory data from element's data attributes
        const quantity = parseInt(element.dataset.inventoryQuantity) || 0;
        const threshold = parseInt(element.dataset.inventoryThreshold) || 10;
        const policy = element.dataset.inventoryPolicy || 'deny';
        
        console.log('[INVENTORY DEBUG] Detecting status from data:', {
          quantity: quantity,
          threshold: threshold,
          policy: policy
        });
        
        // Determine status based on actual inventory data
        if (quantity <= 0) {
          // Out of stock - check if backorder is allowed
          if (policy === 'continue') {
            return 'backorder';
          } else {
            return 'backorder'; // For made-to-order business, always backorder
          }
        } else if (quantity <= threshold) {
          // Quantity is at or below threshold
          return 'low';
        } else {
          // Quantity is above threshold
          return 'in_stock';
        }
      }
      
      // Update the button's data-status based on current inventory
      function updateButtonStatus() {
        const currentStatus = detectCurrentStatus();
        if (infoButton) {
          const oldStatus = infoButton.dataset.status;
          infoButton.dataset.status = currentStatus;
          console.log(`[INVENTORY DEBUG] Status change: ${oldStatus} -> ${currentStatus}`);
        }
      }
      
      // Watch for changes to inventory data attributes (when variant changes)
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && 
              (mutation.attributeName === 'data-inventory-quantity' || 
               mutation.attributeName === 'data-inventory-threshold' ||
               mutation.attributeName === 'data-inventory-policy')) {
            console.log('[INVENTORY DEBUG] Inventory data changed, updating status...');
            updateButtonStatus();
          }
        });
      });
      
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['data-inventory-quantity', 'data-inventory-threshold', 'data-inventory-policy']
      });
      
      // Initial status update
      updateButtonStatus();
      
      console.log(`[INVENTORY DEBUG] Element ${index}:`, {
        hasInfoButton: !!infoButton,
        hasPopup: !!popup,
        buttonStatus: infoButton?.dataset?.status,
        detectedStatus: detectCurrentStatus(),
        inventoryQuantity: element.dataset.inventoryQuantity,
        inventoryThreshold: element.dataset.inventoryThreshold,
        inventoryPolicy: element.dataset.inventoryPolicy,
        inStockTextLength: inStockText.length,
        lowStockTextLength: lowStockText.length,
        backorderTextLength: backorderText.length,
        inStockTextPreview: inStockText.substring(0, 50),
        lowStockTextPreview: lowStockText.substring(0, 50),
        backorderTextPreview: backorderText.substring(0, 50),
        popupInitialContent: popupText?.innerHTML?.substring(0, 100)
      });
      
      if (infoButton && popup) {
        // Move popup to body when opening
        infoButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Get the status from the button's data attribute
          const status = infoButton.dataset.status;
          
          console.log(`[INVENTORY DEBUG] Button clicked:`, {
            elementIndex: index,
            status: status,
            statusType: typeof status,
            statusExactValue: JSON.stringify(status)
          });
          
          // Update popup content based on status
          if (popupText) {
            let htmlContent = '';
            if (status === 'in_stock') {
              htmlContent = inStockText;
              console.log('[INVENTORY DEBUG] Using in_stock text');
            } else if (status === 'low') {
              htmlContent = lowStockText;
              console.log('[INVENTORY DEBUG] Using low stock text');
            } else if (status === 'backorder') {
              htmlContent = backorderText;
              console.log('[INVENTORY DEBUG] Using backorder text');
            } else {
              console.log('[INVENTORY DEBUG] WARNING: Unknown status:', status);
            }
            
            console.log('[INVENTORY DEBUG] Selected content:', {
              htmlContentLength: htmlContent.length,
              htmlContentPreview: htmlContent.substring(0, 100)
            });
            
            // Decode HTML entities
            const textarea = document.createElement('textarea');
            textarea.innerHTML = htmlContent;
            const decodedContent = textarea.value;
            
            console.log('[INVENTORY DEBUG] After decoding:', {
              decodedContentLength: decodedContent.length,
              decodedContentPreview: decodedContent.substring(0, 100)
            });
            
            popupText.innerHTML = decodedContent;
          }
          
          document.body.appendChild(popup);
          popup.dataset.open = 'true';
          popup.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          closeButton.focus();
        });
        
        const closePopup = function() {
          popup.dataset.open = 'false';
          popup.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          // Move popup back to its original location
          element.appendChild(popup);
          infoButton.focus();
        };
        
        closeButton.addEventListener('click', closePopup);
        overlay.addEventListener('click', closePopup);
        
        // Close on Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && popup.dataset.open === 'true') {
            closePopup();
          }
        });
      }
    }
    
    // Initialize all inventory elements on page load
    function initAll() {
      const inventoryElements = document.querySelectorAll('product-inventory');
      console.log('[INVENTORY DEBUG] Found inventory elements:', inventoryElements.length);
      inventoryElements.forEach((element, index) => {
        initInventoryElement(element, index);
      });
    }
    
    // Initial initialization
    initAll();
    
    // Listen for Shopify variant change events
    document.addEventListener('variant:change', function(event) {
      console.log('[INVENTORY DEBUG] Variant change event detected');
      
      // Get the new variant ID from the event or form
      let variantId = null;
      if (event.detail && event.detail.variant) {
        variantId = event.detail.variant.id;
      } else {
        // Fallback: get from form input
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
          variantId = variantInput.value;
        }
      }
      
      console.log('[INVENTORY DEBUG] New variant ID:', variantId);
      
      if (variantId) {
        // Fetch the updated page content for the new variant
        fetch(`${window.location.pathname}?variant=${variantId}`)
          .then(response => response.text())
          .then(html => {
            console.log('[INVENTORY DEBUG] Fetched updated HTML for variant');
            
            const parser = new DOMParser();
            const newDocument = parser.parseFromString(html, 'text/html');
            const newInventory = newDocument.querySelector('product-inventory');
            const currentInventory = document.querySelector('product-inventory');
            
            if (newInventory && currentInventory) {
              // Get the new inventory data attributes
              const newQuantity = newInventory.dataset.inventoryQuantity;
              const newThreshold = newInventory.dataset.inventoryThreshold;
              const newPolicy = newInventory.dataset.inventoryPolicy;
              
              console.log('[INVENTORY DEBUG] New inventory data:', {
                quantity: newQuantity,
                threshold: newThreshold,
                policy: newPolicy
              });
              
              // Update the current element's data attributes
              currentInventory.dataset.inventoryQuantity = newQuantity;
              currentInventory.dataset.inventoryThreshold = newThreshold;
              currentInventory.dataset.inventoryPolicy = newPolicy;
              
              // Update the inventory text content
              const newStatus = newInventory.querySelector('.product-inventory__text');
              const currentStatus = currentInventory.querySelector('.product-inventory__text');
              if (newStatus && currentStatus) {
                currentStatus.innerHTML = newStatus.innerHTML;
                console.log('[INVENTORY DEBUG] Updated inventory text');
              }
              
              // Re-initialize to update button status and event handlers
              setTimeout(function() {
                initAll();
              }, 100);
            }
          })
          .catch(error => {
            console.error('[INVENTORY DEBUG] Error fetching variant update:', error);
          });
      }
    });
    
    // Also listen for custom events that might be triggered
    document.addEventListener('variantChange', function(event) {
      console.log('[INVENTORY DEBUG] Custom variantChange event detected');
      document.dispatchEvent(new CustomEvent('variant:change', { detail: event.detail }));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
